// extracted by mini-css-extract-plugin
export default {"proverb-grid-container":"ProverbGrid_proverb-grid-container__D8YPf","proverb-grid":"ProverbGrid_proverb-grid__L9cri"};